import { LitElement, html, nothing } from 'lit';
import { DebugService } from '../../../shared/services/debug.service.js';
import { style } from './step-coborrower.style.js';
import { ApplicationService } from '../../../services/application.service.js';
import { globalStyle } from '../../../global-styles.style.js';
import { validateForm } from '../../../shared/decorators/validate-form.decorator.js';

class RefiStepCoborrowerComponent extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiStepCoborrower');
    this.validity = {};
    this.coapplicantChildId = 'coapp-name-input';
  }

  static properties = {
    application: { type: Object, reflect: true },
    applicant: { type: Object, reflect: true },
    isPrefill: { type: Boolean, attribute: 'is-prefill' },
    isJointApplication: { type: Boolean, reflect: true },
  };

  static styles = [style, globalStyle];

  connectedCallback() {
    super.connectedCallback();
    this.isJointApplication =
      ApplicationService.Application.applicationType === 'JOINT';
  }

  render() {
    return html`
      <form
        id="step-communication-form"
        class="step-communication-form"
        @submit="${this.onSubmit}"
        novalidate
      >
        <refi-toggle-coborrower
          @toggle-coborrower="${() => {
            this.isJointApplication = !this.isJointApplication;
            if (!this.isJointApplication) {
              this.validity = {};
            }
          }}"
        ></refi-toggle-coborrower>
        ${this.isJointApplication
          ? html`<refi-personal-name
              id="${this.coapplicantChildId}"
              ?hidden="${!this.isJointApplication}"
              @validity="${this.updateValidity}"
              applicant-type="coApplicant"
            >
              <div slot="firstName">First name of co-applicant</div>
              <fs-body-text slot="lastName"
                >Last name of co-applicant</fs-body-text
              >
            </refi-personal-name>`
          : nothing}

        <div class="button-container">
          <fs-button class="fs-button next-button" variant="primary"
            ><span>${!this.isPrefill ? 'Next' : 'Confirm'}</span>
          </fs-button>
        </div>
      </form>
    `;
  }

  updateValidity(ev) {
    this.validity[ev.detail.name] = ev.detail.isValid;
  }

  @validateForm()
  async onSubmit() {
    let valid = true;
    this.debug.log(this.validity);
    Object.values(this.validity).forEach((validityValue) => {
      if (!validityValue) {
        valid = false;
      }
    });

    this.coapplicantChild = this.shadowRoot.getElementById(
      this.coapplicantChildId
    );
    if (valid) {
      // Build coApplicant updates
      let coApplicantUpdates = {};
      if (this.coapplicantChild) {
        Object.keys(this.coapplicantChild.values).forEach((field) => {
          coApplicantUpdates[field.substring(3)] =
            this.coapplicantChild.values[field];
        });
      }
      if (!this.isJointApplication) {
        coApplicantUpdates = {
          ...coApplicantUpdates,
          firstName: '',
          lastName: '',
        };
      }

      // Update application once with all changes
      ApplicationService.Application = {
        ...ApplicationService.Application,
        applicationType: this.isJointApplication ? 'JOINT' : 'INDIVIDUAL',
        coApplicant: {
          ...ApplicationService.Application.coApplicant,
          ...coApplicantUpdates,
        },
      };

      this.debug.log('valid', ApplicationService.Application);
      this.dispatchEvent(new CustomEvent('next-step'));
    }
  }
}

customElements.define('refi-step-coborrower', RefiStepCoborrowerComponent);
